import { render, staticRenderFns } from "./DamagesInformation.vue?vue&type=template&id=1897d134&scoped=true"
import script from "./DamagesInformation.vue?vue&type=script&lang=js"
export * from "./DamagesInformation.vue?vue&type=script&lang=js"
import style0 from "./DamagesInformation.vue?vue&type=style&index=0&id=1897d134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1897d134",
  null
  
)

export default component.exports